import classnames from 'classnames/bind';
import styles from './AtrributeFields.module.scss';
import { UseFormRegister } from 'react-hook-form';
import { IAttributeGroup } from '../CreateChannelAttributeGroupFlow/types';
import { Dispatch, SetStateAction } from 'react';
import { ImageUpload, Input, Typography } from '@weareopenr/component-library';

const cx = classnames.bind(styles);

export const AttributeFields = ({
  register,
  image,
  setImage,
  placeholders,
  isEditMode,
}: {
  register: UseFormRegister<IAttributeGroup>;
  image: string | File;
  setImage: Dispatch<SetStateAction<string | File>>;
  placeholders: {
    consumer_name?: string;
    description?: string;
    posId?: string;
  };
  isEditMode?: boolean;
}) => {
  return (
    <>
      {!isEditMode && <Typography size="medium">Channels will use existing attribute values by default</Typography>}
      <div className={cx('input-container')}>
        <Input
          register={register('consumerName')}
          type="text"
          label="Consumer Name"
          placeholder={placeholders.consumer_name || undefined}
        />
        <Input
          register={register('description')}
          type="text"
          label="Description"
          placeholder={placeholders.description || undefined}
        />
        <Input register={register('plu')} type="text" label="POS ID" placeholder={placeholders.posId || undefined} />
      </div>
      <ImageUpload prompt="Image" image={image} setImage={setImage} title="Image" />
    </>
  );
};
